export default __webpack_public_path__ + "static/media/UNIONBANK_PERSONAL.3e62b722.svg";